import { onMounted, onUnmounted, ref } from 'vue';

type Viewport = '2xl' | 'lg' | 'md' | 'sm' | 'xl';

export const useViewport = (): {
    viewport: Ref<Viewport>;
    breakpoints: { [key in Viewport]: number };
} => {
    const viewport = ref<Viewport>('sm');

    // Tailwind's default breakpoints in pixels
    const breakpoints = {
        'sm': 640,
        'md': 768,
        'lg': 1024,
        'xl': 1280,
        '2xl': 1536,
    };

    const updateViewport = (): void => {
        const width = window.innerWidth;

        if (width >= breakpoints['2xl']) {
            viewport.value = '2xl';
        } else if (width >= breakpoints.xl) {
            viewport.value = 'xl';
        } else if (width >= breakpoints.lg) {
            viewport.value = 'lg';
        } else if (width >= breakpoints.md) {
            viewport.value = 'md';
        } else {
            viewport.value = 'sm';
        }
    };

    onMounted(() => {
        updateViewport();
        window.addEventListener('resize', updateViewport);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', updateViewport);
    });

    return {
        viewport,
        breakpoints,
    };
};
